import getComputedStyle from "./getComputedStyle.js";
import { isHTMLElement } from "./instanceOf.js";

var toNumber = function toNumber(cssValue) {
  return parseFloat(cssValue) || 0;
};

export default (function (element) {
  var computedStyle = isHTMLElement(element) ? getComputedStyle(element) : {};
  return {
    top: toNumber(computedStyle.borderTop),
    right: toNumber(computedStyle.borderRight),
    bottom: toNumber(computedStyle.borderBottom),
    left: toNumber(computedStyle.borderLeft)
  };
});